const localizers = {
  'loading.msg': () => `جارٍ التحميل...`,
  'logon.message.msg': () => `المصادقة مطلوبة. أدخل كلمة مرور ومعرف مستخدم صالح.`,
  'logon.button.msg': () => `تسجيل الدخول...`,
  'SASServer.logonError.msg': () => `يتعذر تسجيل الدخول إلى الخادم.`,
  'SASServer.genericError.msg': () => `لا يمكن الوصول إلى الخادم.`,
}
export default localizers;
